// Help to sleep the application before continue
// Similar to "sleep" in other languages
export function timeout(delay) {
  return new Promise((res) => setTimeout(res, delay));
}
